export const QuickActionBtn = {
  extends: 'Link',
  flow: 'x',
  gap: 'Z',
  align: 'center center',
  padding: 'Z A',
  background: 'surfaceBorder',
  border: '1px solid surfaceBorderStrong',
  borderRadius: 'Z',
  color: 'text',
  fontSize: 'A',
  fontWeight: '500',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'background 150ms',
  href: '#',

  ActionIcon: {
    extends: 'Icon',
    icon: 'plus',
    width: 'Z',
    height: 'Z',
    color: 'green',
  },
  ActionText: {},
}
